import React from'react';import PropTypes from'prop-types';import Row from"./Row";/**
 * Renders rows of product properties.
 * @param {Object} props The component props.
 * @returns {JSX.Element}
 */var Rows=function Rows(_ref){var properties=_ref.properties;return properties.map(function(_ref2){var value=_ref2.value,label=_ref2.label;return React.createElement(Row,{key:"".concat(label,"-").concat(value),label:label,value:value});});};export default React.memo(Rows);